import { useAtomValue } from 'jotai';

import { NcVerifyIdentityPage } from './NcVerifyIdentityPage';
import { NcVerifyIdentityReturningCustomerPage } from './NcVerifyIdentityReturningCustomerPage';
import { isReturningCustomerFlowAtom } from '../../store';

export const NcVerifyIdentityRouting: React.FC = () => {
  const isReturningCustomerFlow = useAtomValue(isReturningCustomerFlowAtom);

  return isReturningCustomerFlow ? <NcVerifyIdentityReturningCustomerPage /> : <NcVerifyIdentityPage />;
};
